import { UserLocationDto } from '../api/dto/user.dto'
import { ContactData } from '../models/user.model'

const fromDtoToModelTransformer = (dto: UserLocationDto): ContactData => {
  return { ...dto }
}

export default fromDtoToModelTransformer
